import React, { useMemo, useEffect } from 'react';
import { useSelector } from 'react-redux';
import BeePlugin from '@mailupinc/bee-plugin';
import { selectedOrganizationSelector } from '../../../../redux/selectors/organization';
import { FullScreenContainer } from './BeeFileManager.styled';

const CLIENT_ID = `${process.env.REACT_APP_BEE_MEDIA_MANAGER_CLIENT}`;
const CLIENT_SECRET = `${process.env.REACT_APP_BEE_MEDIA_MANAGER_SECRET}`;

const BeeFileManager = () => {
  const beeEditor = useMemo(() => new BeePlugin(), []);
  const organizationId = useSelector(selectedOrganizationSelector).id;
  const { userHandle, username, userColor } = useSelector(state => ({
    userHandle: state.user.detail._id,
    username: `${state.user.detail.firstName} ${state.user.detail.lastName}`,
    userColor: state.user.detail.avatarColor,
    beeAdmin: state.user.userPrivileges?.beeAdmin,
  }));

  const beeConfig = {
    uid: organizationId,
    userHandle,
    username,
    userColor,
    container: 'bee-plugin-file-manager',
    language: 'en-US',
    trackChanges: true,
    loadingSpinnerDisableOnDialog: true,
    onError: error => console.error('bee editor error:', error),
    onWarning: warning => console.warn('bee editor warning:', warning),
  };

  const loadFileManager = async () => {
    await beeEditor.start(beeConfig, {});
  };

  useEffect(() => {
    beeEditor
      .getToken(CLIENT_ID, CLIENT_SECRET)
      .then(loadFileManager)
      .catch(error => {
        console.error('Error in loading bee editor', error);
      });
  }, []);

  return <FullScreenContainer id="bee-plugin-file-manager" />;
};

export default BeeFileManager;
